/**
  * ScandiPWA - Progressive Web App for Magento
  *
  * Copyright © Scandiweb, Inc. All rights reserved.
  * See LICENSE for license details.
  *
  * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
  * @package scandipwa/scandipwa
  * @link https://github.com/scandipwa/scandipwa
  */

import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';

import ProductBundleOption from 'Component/ProductBundleOption';
import { RefType } from 'Type/Common.type';
import { ProductItemsType } from 'Type/ProductList.type';

import './ProductBundleOptions.style';

/**
 * Product Bundle Options
 * @class ProductBundleOptions
 * @namespace Pwa/Component/ProductBundleOptions/Component/ProductBundleOptionsComponent */
export class ProductBundleOptionsComponent extends PureComponent {
    static propTypes = {
        options: ProductItemsType.isRequired,
        updateSelectedValues: PropTypes.func.isRequired,
        configFormRef: RefType

    };

    static defaultProps = {
        configFormRef: createRef()
    };

    renderOptionGroup(group) {
        const {
            title,
            options,
            type,
            required,
            uid,
            option_id
        } = group;

        const { updateSelectedValues, configFormRef } = this.props;

        console.log('yanu88', this.props, group);

        return (
            <ProductBundleOption
              key={ option_id }
              title={ title }
              options={ options }
              type={ type }
              isRequired={ required }
              required={ required }
              updateSelectedValues={ updateSelectedValues }
              uid={ uid }
              ref={ configFormRef }
              option_id={ option_id }
            />
        );
    }

    render() {
        const { options = [] } = this.props;

        return (
          <div block="ProductBundleOptions" elem="Wrapper">
              { options.map(this.renderOptionGroup.bind(this)) }
          </div>
        );
    }
}

export default ProductBundleOptionsComponent;
